import { keepPreviousData, queryOptions } from "@tanstack/react-query";

import { roleService, RoleFiltrosCriteria } from "@/services/api/RoleService";

const MINUTE = 1000 * 60;
const LIST_STALE = 30 * 1000; // 30s
const FILTROS_STALE = 30 * MINUTE; // módulos são estáticos

export const rolesKeys = {
  list: ["roles-listagem"] as const,
  filtros: ["roles-filtros"] as const,
};

export const rolesQueries = {
  list: (criteria: RoleFiltrosCriteria) =>
    queryOptions({
      queryKey: [...rolesKeys.list, criteria],
      queryFn: () => roleService.listRolesPaginado(criteria),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE,
    }),

  filtros: () =>
    queryOptions({
      queryKey: rolesKeys.filtros,
      queryFn: () => roleService.getFiltros(),
      staleTime: FILTROS_STALE,
    }),
};
